
export default class GridPaginationElement extends HTMLElement {
    constructor(){
        super();
    }
}

customElements.define('grid-pagination', GridPaginationElement);